import request from "@/api/request";

// 查找好友列表
export function getUserTmpChatMsgs() {
  return request({
    url: "/api/friendApi/getUserTmpChatMsgs",
    method: "post",
  });
}

// 获取最新的消息
export function getMessageFromLast(data) {
  return request({
    url: "/api/friendApi/getLast10MsgList",
    method: "post",
    data: data,
    params: data,
  });
}
export function getGroupMessageFromLast(data) {
  return request({
    url: "/api/system/group/getLastMsgList",
    method: "get",
    data: data,
    params: data,
  });
}

// 获取某个时间点之前的数据
export function getMessageBefore(data) {
  return request({
    url: "/api/friendApi/getMessageBefore",
    method: "post",
    data: data,
    params: data,
  });
}

export function getGroupMessageBefore(data) {
  return request({
    url: "/api/system/group/getMessageBefore",
    method: "post",
    data: data,
    params: data,
  });
}

// 获取最近聊天的好友及未读条数
export function getTmpChatList() {
  return request({
    url: "/api/friendApi/getChatList",
    method: "post",
  });
}

// 获取当前用户的群聊列表
export function getTmpGroupList(data) {
  return request({
    url: "/api/system/group/listGroup",
    method: "get",
    params: data,
  });
}

export function getFriendInfoById(data) {
  return request({
    url: "/api/friendApi/getFriendInfoById",
    method: "post",
    data: data,
    params: data,
  });
}

export function getGroupInfoById(data) {
  return request({
    url: "/api/system/group/getGroupInfoById",
    method: "post",
    data: data,
    params: data,
  });
}

// 将消息置为已读
export function setMessageReaded(data) {
  return request({
    url: "/api/friendApi/setMessageReaded",
    method: "post",
    data: data,
    params: data,
  });
}
export function setGroupMessageReaded(data) {
  return request({
    url: "/api/system/group/readGroupMessage",
    method: "post",
    data: data,
    params: data,
  });
}

// 创建群组
export function createChatGroup(data) {
  return request({
    url: "/api/system/group/create",
    method: "post",
    data: data,
    params: data,
  });
}
